import React, { useEffect, useState } from 'react';

// Material UI
import Chip from '@mui/material/Chip';
import { JobStatus } from '../../api/api';

// Import our store

// API

// Types
interface Props {
  jobStatus : JobStatus
}

const JobStatusChip = ({ jobStatus }: Props) => {

  const getColorForJobStatus = (myJobStatus : JobStatus) : string => {
    switch (JobStatus[myJobStatus] as unknown as JobStatus) {
      case JobStatus.NON_EXISTENT:
        return "#FF0000";
      case JobStatus.DELETED:
        return "#F6AE2D";
      case JobStatus.FINISHED_WITH_ERROR:
        return "#8C2F39";
      case JobStatus.FINISHED_WITH_RESULTS:
        return "#036D19";
      case JobStatus.QUEUED: 
        return "#33658A";
      case JobStatus.RUNNING:
        return "#55DDE0";        
    }
  }

  return (
    <Chip label={jobStatus} variant="outlined" style={{"backgroundColor": getColorForJobStatus(jobStatus)}}/>
  );
};

export default JobStatusChip;